/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateNeighborhoodsNewSignupsPauseStatus} from '../api'

export const useMutationUpdateNeighborhoodsNewSignupsPauseStatus = createReactQueryMutationHook('updateNeighborhoodsNewSignupsPauseStatus', updateNeighborhoodsNewSignupsPauseStatus)
